module.exports = __webpack_public_path__ + "img/news8-3.03156e78.png";